import { signalSessionEnded } from "./tokenStore";

export const TERMINAL_WEBSOCKET_CLOSE_CODES = new Set([4400, 4403, 4404]);

const publishWebSocketStatus = (kind, path, code, message) => {
  window.dispatchEvent(
    new CustomEvent("bp-websocket-status", {
      detail: { kind, path, code, message },
    })
  );
};

export const clearWebSocketStatus = (path = "") => {
  window.dispatchEvent(
    new CustomEvent("bp-websocket-status-clear", {
      detail: { path },
    })
  );
};

export const handleWebSocketClose = (event, path = "") => {
  switch (event.code) {
    case 4400:
      publishWebSocketStatus(
        "message_error",
        path,
        event.code,
        "The message could not be sent. Correct it and try again."
      );
      return false;
    case 4401:
      // An access token expiring does not mean the refresh-backed session has
      // ended. Let the socket reconnect and request a fresh single-use ticket;
      // that HTTP request will refresh the access token when necessary. A
      // failed refresh remains terminal through the API interceptor.
      return true;
    case 4403:
      signalSessionEnded("invalid_or_revoked_session");
      return false;
    case 4404:
      publishWebSocketStatus(
        "resource_unavailable",
        path,
        event.code,
        "This resource is unavailable."
      );
      return false;
    default:
      return true;
  }
};

export const handleWebSocketTicketError = (error, path = "") => {
  const status = error?.response?.status;
  if (error?.__bpWebSocketLifecycleHandled) {
    return ![401, 404].includes(status);
  }
  if (error) error.__bpWebSocketLifecycleHandled = true;
  if (status === 404) {
    publishWebSocketStatus("resource_unavailable", path, 4404, "This resource is unavailable.");
    return false;
  }
  if (status === 401) {
    signalSessionEnded("authentication_failed");
    return false;
  }
  return true;
};
